module.exports = __webpack_public_path__ + "static/media/Frame.68b72a90.svg";